import { inIframe } from '@iheartjane/utils';

import { postMessageToIframeParent } from '@jane/shared/util';

export const scrollToTop = () => {
  const isInIframe = inIframe();

  return isInIframe
    ? postMessageToIframeParent({
        messageType: 'scrollToTop',
        payload: 'smooth',
      })
    : window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
};
